/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
export type SourceAttributionInput = {
    readonly guestUserId?: string | null;
    readonly landingPage?: string | null;
    readonly type: string;
    readonly userId: string;
    readonly userToken?: string | null;
    readonly emailToken?: string | null;
    readonly visitCount?: number | null;
    readonly pageVisits?: ReadonlyArray<pageVisits | null> | null;
    readonly clientMutationId?: string | null;
};
export type pageVisits = {
    readonly date?: string | null;
    readonly type?: string | null;
    readonly utmParams?: utmParams | null;
};
export type utmParams = {
    readonly landingPage?: string | null;
    readonly visitCount?: number | null;
};
export type sourceAttributionMutationVariables = {
    readonly input: SourceAttributionInput;
};
export type sourceAttributionMutationResponse = {
    readonly sourceAttribution: {
        readonly message: string | null;
    } | null;
};
export type sourceAttributionMutation = {
    readonly response: sourceAttributionMutationResponse;
    readonly variables: sourceAttributionMutationVariables;
};



const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "SourceAttributionInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "sourceAttribution",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "SourceAttributionPayload",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "message",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "sourceAttributionMutation",
    "type": "Mutations",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "sourceAttributionMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "sourceAttributionMutation",
    "id": "ferrum/235.0.0-2019-10-02T11:01:37.608Z/sourceAttributionMutation",
    "text": null,
    "metadata": {}
  }
};
})();
(node as any).hash = '0776fc099f129d46b7995c62aa8613ee';
export default node;
